(() => {
  angular
    .module('complianceFrameworkApp')
    .constant('usStates', usStates())
    .constant('fiTypes', fiTypes())
    .constant('notificationTypes', notificationTypes())
    .constant('paymentTypes', paymentTypes())
    .constant('publishedStatuses', publishedStatuses())
    .constant('calendarEventTypes', calendarEventTypes())
    .constant('calendarRegulationTypes', calendarRegulationTypes())
    .constant('calendarProposalStatuses', calendarProposalStatuses())
    .constant('agencyTypes', agencyTypes());

  function usStates() {
    return [
      {
        'name': 'Alabama',
        'abbreviation': 'AL'
      },
      {
        'name': 'Alaska',
        'abbreviation': 'AK'
      },
      {
        'name': 'Arizona',
        'abbreviation': 'AZ'
      },
      {
        'name': 'Arkansas',
        'abbreviation': 'AR'
      },
      {
        'name': 'California',
        'abbreviation': 'CA'
      },
      {
        'name': 'Colorado',
        'abbreviation': 'CO'
      },
      {
        'name': 'Connecticut',
        'abbreviation': 'CT'
      },
      {
        'name': 'Delaware',
        'abbreviation': 'DE'
      },
      {
        'name': 'District Of Columbia',
        'abbreviation': 'DC'
      },
      {
        'name': 'Florida',
        'abbreviation': 'FL'
      },
      {
        'name': 'Georgia',
        'abbreviation': 'GA'
      },
      {
        'name': 'Hawaii',
        'abbreviation': 'HI'
      },
      {
        'name': 'Idaho',
        'abbreviation': 'ID'
      },
      {
        'name': 'Illinois',
        'abbreviation': 'IL'
      },
      {
        'name': 'Indiana',
        'abbreviation': 'IN'
      },
      {
        'name': 'Iowa',
        'abbreviation': 'IA'
      },
      {
        'name': 'Kansas',
        'abbreviation': 'KS'
      },
      {
        'name': 'Kentucky',
        'abbreviation': 'KY'
      },
      {
        'name': 'Louisiana',
        'abbreviation': 'LA'
      },
      {
        'name': 'Maine',
        'abbreviation': 'ME'
      },
      {
        'name': 'Maryland',
        'abbreviation': 'MD'
      },
      {
        'name': 'Massachusetts',
        'abbreviation': 'MA'
      },
      {
        'name': 'Michigan',
        'abbreviation': 'MI'
      },
      {
        'name': 'Minnesota',
        'abbreviation': 'MN'
      },
      {
        'name': 'Mississippi',
        'abbreviation': 'MS'
      },
      {
        'name': 'Missouri',
        'abbreviation': 'MO'
      },
      {
        'name': 'Montana',
        'abbreviation': 'MT'
      },
      {
        'name': 'Nebraska',
        'abbreviation': 'NV'
      },
      {
        'name': 'Nevada',
        'abbreviation': 'NV'
      },
      {
        'name': 'New Hampshire',
        'abbreviation': 'NH'
      },
      {
        'name': 'New Jersey',
        'abbreviation': 'NJ'
      },
      {
        'name': 'New Mexico',
        'abbreviation': 'NM'
      },
      {
        'name': 'New York',
        'abbreviation': 'NY'
      },
      {
        'name': 'North Carolina',
        'abbreviation': 'NC'
      },
      {
        'name': 'North Dakota',
        'abbreviation': 'ND'
      },
      {
        'name': 'Ohio',
        'abbreviation': 'OH'
      },
      {
        'name': 'Oklahoma',
        'abbreviation': 'OK'
      },
      {
        'name': 'Oregon',
        'abbreviation': 'OR'
      },
      {
        'name': 'Pennsylvania',
        'abbreviation': 'PA'
      },
      {
        'name': 'Rhode Island',
        'abbreviation': 'RI'
      },
      {
        'name': 'South Carolina',
        'abbreviation': 'SC'
      },
      {
        'name': 'South Dakota',
        'abbreviation': 'SD'
      },
      {
        'name': 'Tennessee',
        'abbreviation': 'TN'
      },
      {
        'name': 'Texas',
        'abbreviation': 'TX'
      },
      {
        'name': 'Utah',
        'abbreviation': 'UT'
      },
      {
        'name': 'Vermont',
        'abbreviation': 'VT'
      },
      {
        'name': 'Virginia',
        'abbreviation': 'VA'
      },
      {
        'name': 'Washington',
        'abbreviation': 'WA'
      },
      {
        'name': 'West Virginia',
        'abbreviation': 'WV'
      },
      {
        'name': 'Wisconsin',
        'abbreviation': 'WI'
      },
      {
        'name': 'Wyoming',
        'abbreviation': 'WY'
      }
    ];
  }

  function publishedStatuses() {
    return [
      {
        name: 'Published',
        value: 'published'
      },
      {
        name: 'Unpublished',
        value: 'unpublished'
      },
      {
        name: 'Archived',
        value: 'archived'
      },
      {
        name: 'All',
        value: '!null'
      }
    ];
  }

  function paymentTypes() {
    return [
      {
        name: 'Credit Card',
        value: 'credit_card'
      },
      {
        name: 'ACH',
        value: 'ach'
      }
    ];
  }

  function fiTypes() {
    return [
      {
        name: 'Bank',
        value: 'bank'
      },
      {
        name: 'Credit Union',
        value: 'credit_union'
      },
      {
        name: 'Mortgage Company',
        value: 'mortgage_company'
      },
      {
        name: 'Consulting Firm',
        value: 'consulting_firm'
      },
      {
        name: 'Farm Credit',
        value: 'farm_credit'
      }
    ];
  }

  function notificationTypes() {
    return ['Contract Expiration', 'Contract Renewal', 'Expiring Document', 'Missing Document', 'Expiring Risk Assessment'];
  }

  function calendarEventTypes() {
    return [
      {
        name: 'Regulatory',
        value: 'regulatory'
      },
      {
        name: 'Temenos',
        value: 'temenos'
      },
      {
        name: 'My Events',
        value: 'fi'
      }
    ];
  }

  function calendarRegulationTypes() {
    return [
      {
        name: 'Notice',
        value: 'notice'
      },
      {
        name: 'Rule',
        value: 'rule'
      },
      {
        name: 'Guidance',
        value: 'guidance'
      },
      {
        name: 'Other',
        value: 'other'
      }
    ];
  }

  function calendarProposalStatuses() {
    return [
      {
        name: 'Notice',
        value: 'notice',
        color: 'primary'
      },
      {
        name: 'Guidance',
        value: 'guidance',
        color: 'secondary'
      },
      {
        name: 'Final Rule',
        value: 'final_rule',
        color: 'success'
      },
      {
        name: 'Proposed',
        value: 'proposed',
        color: 'danger'
      },
      {
        name: 'Reports',
        value: 'reports',
        color: 'warning'
      },
      {
        name: 'News',
        value: 'news',
        color: 'info'
      },
      {
        name: 'Training',
        value: 'training',
        color: 'dark'
      },
      {
        name: 'Request for Information',
        value: 'request_for_information',
        color: 'purple'
      },
      {
        name: 'My Events',
        value: 'my_events',
        color: 'my-events'
      }
    ];
  }

  function agencyTypes() {
    return [
      { 
        name: 'interagency',
        value: 'Interagency'
      },
      {
        name: 'ncua',
        value: 'NCUA'
      },
      {
        name: 'fdic',
        value: 'FDIC'
      },
      {
        name: 'occ',
        value: 'OCC'
      },
      {
        name: 'frb',
        value: 'FRB'
      },
      {
        name: 'fca',
        value: 'FCA'
      },
      {
        name: 'fhfa',
        value: 'FHFA'
      },
      {
        name: 'hud',
        value: 'HUD'
      },
      {
        name: 'fema',
        value: 'FEMA'
      },
      {
        name: 'cfpb',
        value: 'CFPB'
      },
      {
        name: 'fincen',
        value: 'FINCEN'
      },
      {
        name: 'ffiec',
        value: 'FFIEC'
      },
      {
        name: 'ftc',
        value: 'FTC'
      },
      {
        name: 'fcc',
        value: 'FCC'
      },
      {
        name: 'dod',
        value: 'DoD'
      },
      {
        name: 'ofac',
        value: 'OFAC'
      },
      {
        name: 'fditech',
        value: 'FDiTech'
      },
      {
        name: 'fha',
        value: 'FHA'
      }
    ];
  }
})();
